var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("v-overlay", {
        attrs: { value: _vm.show, opacity: 0.6, "z-index": "10000" },
      }),
      _c(
        "v-snackbar",
        {
          staticClass: "app-update-notification",
          attrs: {
            timeout: -1,
            color: "primary",
            "multi-line": "",
            top: "",
            centered: "",
          },
          scopedSlots: _vm._u([
            {
              key: "action",
              fn: function ({ attrs }) {
                return [
                  _c(
                    "div",
                    { staticClass: "d-flex flex-column flex-sm-row" },
                    [
                      _c(
                        "v-btn",
                        _vm._b(
                          {
                            staticClass: "mr-0 mr-sm-2 mb-2 mb-sm-0",
                            attrs: { text: "", small: "", color: "white" },
                            on: { click: _vm.handleLater },
                          },
                          "v-btn",
                          attrs,
                          false
                        ),
                        [_vm._v(" " + _vm._s(_vm.$t("later")) + " ")]
                      ),
                      _c(
                        "v-btn",
                        _vm._b(
                          {
                            staticClass: "primary--text font-weight-bold",
                            attrs: {
                              color: "white",
                              small: "",
                              disabled: _vm.isOnCall,
                            },
                            on: { click: _vm.handleUpdate },
                          },
                          "v-btn",
                          attrs,
                          false
                        ),
                        [
                          _c(
                            "v-icon",
                            { staticClass: "mr-1", attrs: { small: "" } },
                            [_vm._v("mdi-refresh")]
                          ),
                          _vm._v(" " + _vm._s(_vm.$t("update-now")) + " "),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              },
            },
          ]),
          model: {
            value: _vm.show,
            callback: function ($$v) {
              _vm.show = $$v
            },
            expression: "show",
          },
        },
        [
          _c(
            "div",
            { staticClass: "d-flex align-center" },
            [
              _c(
                "v-icon",
                { staticClass: "mr-3", attrs: { size: "28", color: "white" } },
                [_vm._v("mdi-update")]
              ),
              _c("div", [
                _c(
                  "div",
                  {
                    staticClass: "text-subtitle-1 font-weight-bold white--text",
                  },
                  [
                    _vm._v(
                      " " + _vm._s(_vm.$t("app-update-available-title")) + " "
                    ),
                  ]
                ),
                _c("div", { staticClass: "text-body-2 white--text mt-1" }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("app-update-available-description")) +
                      " "
                  ),
                ]),
                _vm.isOnCall
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "text-body-2 red--text text--lighten-2 mt-2 font-weight-medium",
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("app-update-blocked-on-call")) +
                            " "
                        ),
                      ]
                    )
                  : _vm._e(),
              ]),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }